import config from '../../config.json';

/**
 * Returns the current environment, this can be one of:
 * - local
 * - docker
 * - dev
 * - qa
 * - prod
 * @returns {string} The environment name
 */
export function getEnvironment() {
  const isStorybook = (host) => /localhost:6006$/.exec(host);
  const isLocal = (host) => /^localhost:\d+$/.exec(host);
  const isDocker = (host) => /server.app:\d+$/.exec(host);
  const host = window.location.host;
  const profile = getProfileFromHost(host);

  return isStorybook(host)
    ? 'storybook'
    : isLocal(host)
    ? 'local'
    : isDocker(host)
    ? 'docker'
    : profile;
}

/**
 * Determines if the current environment is hosted in the cloud.
 *
 * @returns {boolean} True if the current environment is hosted in the cloud
 */
export function isHostedEnvironment() {
  return !['local', 'docker', 'storybook'].includes(getEnvironment());
}

/**
 * Fetches a configuration property from the config.json file according to the current environment.
 *
 * For example:
 * `getEnvironmentConfig('api')` will return the value of `config.api[getEnvironment()]`
 *
 * @param {string} property Name of the property to fetch
 * @returns {string} The value of the property
 */
export function getEnvironmentConfig(property) {
  const environment = getEnvironment();
  return getConfigByEnvironment(property, environment);
}

function getConfigByEnvironment(property, env) {
  return env in config[property]
    ? config[property][env]
    : config[property]['default'];
}

function getProfileFromHost(host) {
  const pattern = new RegExp(config.urlToProfileRegex);
  const match = pattern.exec(host);
  return match && match.length > 1 ? match[1] : 'prod';
}
